<template>
    <div>
        <teleport to="body">
            <transition name="modal">
                <div 
                    v-if="show"
                    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
                    <div :class="['relative p-8 rounded-lg shadow-sm border', forceWhite ? 'bg-white border-transparent' : 'bg-white dark:bg-slate-900 border-transparent dark:border-slate-700', widthClass]">
                        <button
                            v-if="!hideClose"
                            :class="['absolute mt-2 mr-2 top-6 right-3', forceWhite ? 'text-gray-700 hover:text-gray-900' : 'text-gray-700 dark:text-slate-300 hover:text-gray-900 dark:hover:text-white']"
                            @click="$emit('close')">
                            <svg 
                                class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" 
                                xmlns="http://www.w3.org/2000/svg">
                                <path 
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                    d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        
                        <slot/>
                    </div>
                </div>
            </transition>
        </teleport>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    show?: boolean,
    size?: 'small' | 'medium' | 'large' | 'xlarge',
    hideClose?: boolean,
    forceWhite?: boolean
}>();

const widthClass = computed(() => {
    switch (props.size) {
        case 'small':
            return 'w-full max-w-sm';
        case 'medium':
            return 'w-full max-w-md';
        case 'large':
            return 'w-full sm:w-3/4 md:w-2/3 lg:w-3/5';
        case 'xlarge':
            return 'w-full sm:w-4/5 md:w-3/4 lg:w-4/5';
        default:
            return 'w-full sm:w-2/3 md:w-1/2 lg:w-2/5'; // Default to medium if size is not provided
    }
});

defineEmits(['close']);
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.5s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;
}
</style>
